import {
  GET_PROVIDER_FAIL,
  GET_PROVIDER_SUCCESS,
  GET_PROVIDERS_FAIL,
  GET_PROVIDERS_SUCCESS,
  ADD_PROVIDER_SUCCESS,
  ADD_PROVIDER_FAIL,
  UPDATE_PROVIDER_SUCCESS,
  UPDATE_PROVIDER_FAIL,
  DELETE_PROVIDER_SUCCESS,
  DELETE_PROVIDER_FAIL,  
  SET_STATE_PROVIDER
} from "./actionTypes";

const INIT_STATE = {
  providers: [],
  provider: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const providers = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PROVIDERS_SUCCESS:
      return {
        ...state,
        providers: action.payload.providers,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_PROVIDER:
      return { ...state, loading: action.payload }

    case GET_PROVIDERS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_PROVIDER_SUCCESS:
      return {
        ...state,
        providers: [...state.providers, action.payload],
      };

    case ADD_PROVIDER_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_PROVIDER_SUCCESS:
      return {
        ...state,
        providers: state.providers.map(provider =>
          provider.id.toString() === action.payload.id.toString()
            ? { ...action.payload, provider }
            : provider
        ),
      };

    case UPDATE_PROVIDER_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_PROVIDER_SUCCESS:
      return {
        ...state,
        providers: state.providers.filter(
          provider => provider.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_PROVIDER_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_PROVIDER_SUCCESS:
      return {
        ...state,
        provider: action.payload,
      };

    case GET_PROVIDER_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default providers;
